import { render, staticRenderFns } from "./finalPredictForm.vue?vue&type=template&id=06576539&scoped=true"
import script from "./finalPredictForm.vue?vue&type=script&lang=js"
export * from "./finalPredictForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06576539",
  null
  
)

export default component.exports